import { trackEvent } from '~/features/analytics/track-event';
import type { BackToSchool2026Phase2Variant } from '~/features/promotions/constants/back-to-school-2026-phase-2-sale';

import type { PromoCampaignSurfaceRenderers } from '../types';

import { BackToSchool2026Phase2PromoBanner } from './back-to-school-2026-phase-2-promo-banner';
import { BackToSchool2026Phase2PromoCard } from './back-to-school-2026-phase-2-promo-card';
import { buildBackToSchool2026Phase2ExperienceCard } from './experience-card';

const BTS_2026_P2_ANALYTICS_LABEL = 'back_to_school_2026_phase_2_sale_clicked';

export const backToSchool2026Phase2CampaignSurfaces: PromoCampaignSurfaceRenderers<BackToSchool2026Phase2Variant>['surfaces'] =
  {
    homepage: ({ resolved, promoCode, imagePriority }) => (
      <BackToSchool2026Phase2PromoCard
        imagePriority={imagePriority}
        promoCode={promoCode}
        variant={resolved}
        onClick={() =>
          trackEvent({
            type: 'click',
            name: 'Homepage CTA Clicked',
            label: BTS_2026_P2_ANALYTICS_LABEL,
          })
        }
      />
    ),
    catalog: ({ resolved, promoCode, imagePriority }) => (
      <BackToSchool2026Phase2PromoBanner
        imagePriority={imagePriority}
        promoCode={promoCode}
        variant={resolved}
        onCtaClick={() =>
          trackEvent({
            type: 'click',
            name: 'Catalog Page CTA Clicked',
            label: BTS_2026_P2_ANALYTICS_LABEL,
          })
        }
      />
    ),
    experience: ({ resolved, promoCode }) => buildBackToSchool2026Phase2ExperienceCard(resolved, promoCode),
  };
